export default __webpack_public_path__ + "static/media/bx-dollar-gray.3db901a8.svg";